import { useState } from "react";
import { Eye, EyeOff } from "lucide-react"; 

const PasswordInput = ({ label = "Password", register, name, errors, validationRules = {}, ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="mb-4 w-full">
      {label && <label className="label label-text">{label}</label>}
      <div className="relative">
        <input
          type={visible ? "text" : "password"}
          {...register(name, validationRules)}
          {...props}
          className="input input-bordered w-full pr-10"
        />
        <button
          type="button"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-700"
          onClick={() => setVisible((v) => !v)}
          tabIndex={-1}
        >
            {visible ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>
      {errors[name] && (
        <label className="label">
            <span className="label-text-alt text-error">{errors[name].message}</span>
        </label>
      )}
    </div>
  );
};

export default PasswordInput;